export default abstract class AbstractConfig {
  constructor(protected readonly configuration: object = {}) {
    //
  }

  public get<T = any>(what: string): T | undefined {
    if (this.has(what)) {
      return (this.configuration as any)[what];
    }

    return undefined;
  }

  public has(what: string): boolean {
    return Object.prototype.hasOwnProperty.call(this.configuration, what);
  }
}
